import { render, staticRenderFns } from "./articlecategory.vue?vue&type=template&id=8d080362&scoped=true&"
import script from "./articlecategory.vue?vue&type=script&lang=js&"
export * from "./articlecategory.vue?vue&type=script&lang=js&"
import style0 from "./articlecategory.vue?vue&type=style&index=0&id=8d080362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d080362",
  null
  
)

export default component.exports